import type { AdminUserRow } from "../types/api";

export interface AdminUserGroup {
  userId: string;
  primary: AdminUserRow;
  rows: AdminUserRow[];
  workspaceRows: AdminUserRow[];
}

export function groupAdminUserRows(rows: AdminUserRow[]): AdminUserGroup[] {
  const rowsByUser = new Map<string, AdminUserRow[]>();

  for (const row of rows) {
    const existing = rowsByUser.get(row.user.id);
    if (existing) existing.push(row);
    else rowsByUser.set(row.user.id, [row]);
  }

  return [...rowsByUser.entries()].map(([userId, userRows]) => {
    const primary =
      userRows.find((row) => row.billing.hasKey) ??
      userRows.find((row) => row.account?.ownerUserId === userId) ??
      userRows[0];

    return {
      userId,
      primary,
      rows: userRows,
      workspaceRows: userRows.filter((row) => row !== primary && row.account != null)
    };
  });
}
